import technologyHandler from "@/services/Technology";

export default {
  async load({ commit }, payload) {
    try {
      const {
        data: { data },
      } = await technologyHandler.all(payload);
      commit("SET_TECHNOLOGY", data);
    } catch (error) {
      commit("SET_TECHNOLOGY", []);
    }
  },
  // eslint-disable-next-line no-unused-vars
  async store({ commit, dispatch }, payload) {
    return technologyHandler.store(payload);
  },
  // eslint-disable-next-line no-unused-vars
  async get({ commit, dispatch }, payload) {
    return technologyHandler.get(payload);
  },
  // eslint-disable-next-line no-unused-vars
  async update({ commit, dispatch }, payload) {
    return technologyHandler.update(payload);
  },
  // eslint-disable-next-line no-unused-vars
  async remove({ commit, dispatch }, payload) {
    return technologyHandler.remove(payload);
  },
  // eslint-disable-next-line no-unused-vars
  async destroy({ commit, dispatch }, payload) {
    return technologyHandler.destroy(payload);
  },
  // eslint-disable-next-line no-unused-vars
  async restore({ commit, dispatch }, payload) {
    return technologyHandler.restore(payload);
  },
};
